import React from 'react';
import SMFormatHelper from 'components/helpers/SMFormatHelper';
import SMFormValidationMessage from 'components/dashboard/form/SMFormValidationMessage';
import SMFormTextField from 'components/dashboard/form/SMFormTextField';
import SMFormCheckBox from 'components/dashboard/form/SMFormCheckBox';
import SMOExtraBusinessHourView from 'components/dashboard/owners/rooms/fragments/SMOExtraBusinessHourView';
import CSSTransitionGroup from 'react-addons-css-transition-group';

class SMOBusinessHoursView extends React.Component {

  render() {
    let extraBusinessHoursView = [];

    // 曜日毎の日付チェックエラー表示部分
    // 曜日の隣にエラー結果は出さないため、エラー内容の重複を省いて表示させる
    const errors = this.props.errors;
    let errorText = '';
    if (errors) {
      let results = [];
      errors.forEach((error) => {
        if (error.resource == 'Room' && error.field.indexOf('room_extra_business_hours') == 0) {
          const temp = results.find(search => search.message == error.message);
          if (temp == null) {
            results.push(error);
          }
        }
      });

      results.forEach((result) => {
        errorText += result.message;
      });
    }

    let extraBusinessHours = [];
    if (this.props.model.room_extra_business_hours) {
      extraBusinessHours = this.props.model.room_extra_business_hours;
    }

    extraBusinessHoursView.push(<SMFormValidationMessage key='msg' name={'room_extra_business_hours'} errorText={errorText} />);
    if (this.props.model.has_extra_business_hours || errorText) {
      I18n.t('date.day_names').forEach(function(item, i) {
        let toggle = false;
        let start = '';
        let end = '';
        let extraBusinessHour = extraBusinessHours.find(e => e.weekday == i);
        if (extraBusinessHour) {
          start = extraBusinessHour.start_hour;
          end = extraBusinessHour.end_hour;
          toggle = true;
        }
        extraBusinessHoursView.push(<SMOExtraBusinessHourView key={i} weekday={i} toggle={toggle} initialBusinessStartHour={start} initialBusinessEndHour={end} />);
      });
    }

    return(
      <div className="form-box">
        <SMFormTextField name="business_start_hour" value={this.props.model.business_start_hour} placeholderText="9" options={{className:'w40'}} delegate={this.props.delegate} /> :00
        <span className="ml5 mr5">〜</span>
        <SMFormTextField name="business_end_hour" value={this.props.model.business_end_hour} placeholderText="20" options={{className:'w40'}} delegate={this.props.delegate} /> :00
        <SMFormValidationMessage name={'business_start_hour'} errorText={SMFormatHelper.errorText('Room', 'business_start_hour', this.props.errors)} />
        <SMFormValidationMessage name={'business_end_hour'} errorText={SMFormatHelper.errorText('Room', 'business_end_hour', this.props.errors)} />

        <div className="mt20 mb10">
          <input type="hidden" value="0" name={'has_extra_business_hours'} />
          <SMFormCheckBox id={"has_extra_business_hours"} name={"has_extra_business_hours"} value={1} checked={this.props.model.has_extra_business_hours} delegate={this.props.delegate} />
          <label htmlFor={'has_extra_business_hours'} className="form-checkbox">貸出可能な時間帯を曜日ごとに設定する</label>
        </div>

        <CSSTransitionGroup transitionName="js-list-fade-animation" transitionEnterTimeout={500} transitionLeaveTimeout={300}>
          {extraBusinessHoursView}
        </CSSTransitionGroup>
      </div>
    );
  }
}

SMOBusinessHoursView.defaultProps = {
  errors: [],
};

export default SMOBusinessHoursView;



// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/owners/rooms/fragments/SMOBusinessHoursView.jsx